export const SOURCE_CODES = {
  wxwrok: '100',
  dingtalk: '104',
  feishu: '106'
};

function setDefault(data = {}, defData = {}) {
  Object.keys(defData).forEach(key => {
    if (data[key] === undefined) {
      data[key] = defData[key];
    }
  });
  return data;
}

function createEnvConf(baseConf, otherConf = {}) {
  setDefault(otherConf, {
    feature: baseConf.dev,
    tcdev: baseConf.dev,
    tcstress: baseConf.stg,
    'tf-ali-01': baseConf.stg,
    'tf-tc-01': baseConf.stg,
    tcprod: baseConf.prod
  });
  return { ...baseConf, ...otherConf };
}

export const APPID_CONF = {
  dingding: createEnvConf(
    {
      dev: '74588',
      stg: '77705',
      prod: '79169'
    },
    { feature: '75414' }
  )
};

export const SERVE_GROUP_CONF = {
  feishu: {
    urls: createEnvConf({
      dev: 'https://applink.feishu.cn/TN9LV4sU',
      stg: 'https://applink.feishu.cn/TNfAt7oA',
      prod: 'https://applink.feishu.cn/TNvVSb6w'
    })
  },
  dingding: {
    goodsCode: 'DT_GOODS_881631004539941',
    token: '6e6a88d411d0df93aa64425f5538315f'
  }
};
const baseCommon = (typeof window !== 'undefined' && window.feConfig && window.feConfig.common);
export const STATIC_BASE_URL = (baseCommon && window.feConfig.common.staticBaseUrl) || 'https://stc.yxt.com/';

export const DING_SDK_URL = STATIC_BASE_URL + 'assets/10eccd18/9ca425c3/dingtalk-jsapi-2.13.42.js';
